import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["orgFields"]

  connect() {
    const checkedInput = this.element.querySelector("input[type='radio']:checked")
    if (checkedInput?.value === "true") {
      this.orgFieldsTarget.style.display = "none"
    }
  }

  selectAccount() {
    this.orgFieldsTarget.style.display = "none"
  }

  selectOrganization() {
    this.orgFieldsTarget.style.display = "block"
  }
}
